import * as React from 'react';

const JobPostingJsonLd: React.FC = () => {
  // ~~아직 지원 안함. Greenhouse 에서 Location 이던 Department 던 공고에 메타데이터 다 넣어야 될듯~~
  // TODO: ca 도메인으로 이전 후에는 하드코딩으로라도 대응 가능함
  return null;
};

export default JobPostingJsonLd;
